import React from "react"

const FileIcon = ({ size = 20, color = "#0183FF", className = "", style = {} }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 40 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={style}
    >
        <path
            d="M4.42553 40.8511H25.5319C21.7872 38.8085 19.234 34.8936 19.234 30.2979C19.234 23.6596 24.6809 18.2128 31.3192 18.2128H31.4894V4.42553C31.4894 2.04255 29.4468 0 27.0638 0H4.42553C2.04255 0 0 2.04255 0 4.42553V36.4255C0 38.8085 1.87234 40.8511 4.42553 40.8511ZM8.34043 6.80851H22.9787C24 6.80851 24.6809 7.65957 24.6809 8.51064C24.6809 9.53192 24 10.2128 22.9787 10.2128H8.34043C7.31915 10.2128 6.6383 9.53192 6.6383 8.51064C6.6383 7.65957 7.48936 6.80851 8.34043 6.80851ZM8.34043 14.8085H17.8723C18.8936 14.8085 19.5745 15.6596 19.5745 16.5106C19.5745 17.5319 18.8936 18.2128 17.8723 18.2128H8.34043C7.31915 18.2128 6.6383 17.5319 6.6383 16.5106C6.6383 15.4894 7.48936 14.8085 8.34043 14.8085Z"
            fill={color}
        />
        <path
            d="M31.3176 21.7872C26.5516 21.7872 22.6367 25.7021 22.6367 30.4681C22.6367 35.234 26.5516 39.1489 31.3176 39.1489C36.0835 39.1489 39.9984 35.234 39.9984 30.4681C39.9984 25.7021 36.0835 21.7872 31.3176 21.7872ZM35.5729 29.617L31.3176 33.7021C30.9771 34.0425 30.6367 34.2128 30.1261 34.2128C29.6154 34.2128 29.275 34.0425 28.9346 33.7021L26.892 31.4894C26.2112 30.8085 26.2112 29.7872 27.0623 29.1064C27.7431 28.4255 28.7644 28.4255 29.4452 29.1064L30.2963 30.1277L33.3601 27.234C34.041 26.5532 35.0622 26.5532 35.7431 27.234C36.2537 27.7447 36.2537 28.9362 35.5729 29.617Z"
            fill={color}
        />
    </svg>
)

export default FileIcon
